/* @flow */
// typecheck: ignore file
import React, { cloneElement, Component, PropTypes } from 'react';

import AlertDialog from 'components/AlertDialog.jsx';
import createChainedFunction from 'utils/createChainedFunction';
import LoadingModal from 'components/LoadingModal.jsx';

/**
 * Default error modal, when a modal without a defined
 * error modal handler (prefetchErrorModal) returned an
 * uncaught error during the prefetch promises resolution.
 *
 * @param {Error} a promise error
 * @return {AlertDialog}
 */
class DefaultErrorDialog extends Component {
  static propTypes = {
    error: PropTypes.shape({ error: PropTypes.string }),
    onRequestHide: PropTypes.func.isRequired,
  };

  render() {
    return (
      <AlertDialog
        onRequestHide={this.props.onRequestHide}
        title="Oops, an error has occurred!"
        subtext={this.props.error && this.props.error.error ? this.props.error.error : ''}
        buttonText="Close"
      />
    );
  }
}

type State = {
  prefetched: boolean,
  prefetchError?: string | {error: string},
};

/**
 * Modal display that prefetch data (via prefetch static prop), a loading indicator will
 * be mounted will the promises are being resolved. If an uncaught error
 * occurs during the promises modal.prefetchErrorModal will be mounted
 *
 * class SomeCoolModal extends Component {
 *   static prefetch = [
 *     (props) => props.fetchSomeCoolData(),
 *     (props) => props.fetchSomeFutherCoolData(),
 *   ]
 *
 *   static prefetchErrorModal = (err) => <AlertDialog title="Cannot get data" subtext={err} />
 * }
 *
 */
export default class ModalPrefetcher extends Component {
  props: {
    modal: React$Element<*>,
    onRequestHide: () => any,
  };

  state: State = {
    prefetched: false,
  };

  componentDidMount() {
    if (this.getPrefetchFns().length > 0) {
      const promises = this.getPrefetchFns().map(
        prefetchFn => prefetchFn(this.props.modal.props)
      );

      Promise.all(promises).then(
        () => this.setState({ prefetched: true }),
        (err) => this.setState({ prefetchError: err || { error: '' } }),
      );
    }
  }

  getPrefetchFns() {
    return this.props.modal.type.prefetch || [];
  }

  getErrorDialog(error: string|Object) {
    return (
      this.props.modal.type.prefetchErrorModal &&
      this.props.modal.type.prefetchErrorModal(error)
    );
  }

  render() {
    if (this.state.prefetchError != null) {
      const errorView = this.getErrorDialog(this.state.prefetchError);

      if (errorView) {
        return cloneElement(errorView, {
          onRequestHide: createChainedFunction(
            errorView.props.onRequestHide,
            this.props.onRequestHide,
          ),
        });
      }

      return (
        <DefaultErrorDialog
          error={this.state.prefetchError}
          onRequestHide={this.props.onRequestHide}
        />
      );
    }

    if (this.getPrefetchFns().length > 0 && !this.state.prefetched) {
      return <LoadingModal />;
    }

    return cloneElement(this.props.modal, {
      onRequestHide: createChainedFunction(
        this.props.modal.props.onRequestHide,
        this.props.onRequestHide,
      ),
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalPrefetcher.jsx